import React, { useEffect, useState } from 'react';
import { formatNumber, convertToInt } from '../../../utils';
import { makeStyles } from '@material-ui/core/styles';
import messages from '../../../messages';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme: any) => ({
  field: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    '& .MuiInputBase-input': { width: 80 },
  },
  unitsTextEdit: { marginLeft: theme.spacing(0.5) },
  unitsText: {
    color: theme.palette.brand.greenDark,
  },
}));

export default function Units({
  line,
  setLineInfoDuringEdit,
  addOrDeleteError,
}) {
  const [newInventory, setNewInventory] = useState('');
  const [error, setError] = useState(false);
  const classes = useStyles();
  const currentInventory = newInventory ? convertToInt(newInventory) : null;
  setLineInfoDuringEdit('inventory', currentInventory);
  validateInventory(currentInventory, false);

  useEffect(() => {
    setNewInventory(formatNumber(line.inventory));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function validateInventory(
    inventory: number,
    markFieldRedOnErr: boolean = true,
  ) {
    if (!inventory) {
      markFieldRedOnErr && setError(true);
      addOrDeleteError(
        true,
        'inventory',
        messages.lines.lineEditErrors.inventoryRequired,
      );
    } else if (isNaN(inventory)) {
      markFieldRedOnErr && setError(true);
      addOrDeleteError(
        true,
        'inventory',
        messages.lines.lineEditErrors.inventoryValidNum,
      );
    } else if (inventory <= 0) {
      markFieldRedOnErr && setError(true);
      addOrDeleteError(
        true,
        'inventory',
        messages.lines.lineEditErrors.inventoryPositiveNum,
      );
    } else {
      markFieldRedOnErr && setError(false);
      addOrDeleteError(false, 'inventory');
    }
  }

  function handleInventoryChange(event) {
    let newInventory = convertToInt(event.target.value);
    if (!Number.isInteger(newInventory)) {
      newInventory = 0;
    }
    const formattedInventory = newInventory
      ? formatNumber(newInventory)
      : newInventory?.toString();
    setNewInventory(formattedInventory);
    setLineInfoDuringEdit('inventory', newInventory);
    validateInventory(newInventory);
  }

  return (
    <div className={classes.field}>
      <TextField
        error={error}
        value={newInventory}
        onChange={handleInventoryChange}
      />
      <span className={classes.unitsTextEdit}>units</span>
    </div>
  );
}
